<template>
  <div class="app-checkbox">
    <div class="label" :style="{ width: lableWidth }">{{ label }}</div>
    <div class="checkbox-wrap">
      <el-checkbox
        border
        size="mini"
        @change="handleCheckedChange"
        :value="value"
        true-label=""
      >
        全部
      </el-checkbox>
      <el-checkbox
        border
        size="mini"
        v-for="(item, index) in list"
        :key="index"
        :value="value"
        :true-label="item[valueKey] || item['code'] "
        false-label=""
        @change="handleCheckedChange"
      >
        {{ item[labelKey]||item['name'] }}
      </el-checkbox>
    </div>
  </div>
</template>
<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    label: String,
    lableWidth: { type: String, default: "" },
    labelKey: { type: String, default: "label" },
    valueKey: { type: String, default: "value" },
    list: {
      type: Array,
      default: () => [],
    },
    value: String,
  },
  data() {
    return {};
  },
  methods: {
    handleCheckedChange(value = "") {
      value === false && (value = "");
      this.$emit("change", value);
    },
  },
};
</script>
<style scoped lang="less">
.app-checkbox {
  display: flex;
  .label {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #595959;
    line-height: 24px;
  }
  .checkbox-wrap {
    flex: 1;
    ::v-deep .el-checkbox {
      padding: 0 12px;
      margin: 0;
      border: none;
      height: 24px;
      font-family: MicrosoftYaHei;
      color: #262626;
      line-height: 24px;
      margin-bottom: 10px;
      &.is-checked {
        background: #368fff;
        .el-checkbox__label {
          color: #fff;
        }
      }
      .el-checkbox__input {
        display: none;
      }
      .el-checkbox__label {
        font-size: 14px;
        padding-left: 0;
      }
    }
  }
}
</style>